// El SDK de Datadog trae literales BigInt (1n), que un navegador sin BigInt no puede ni parsear: en Datadog RUM hay un
// TV de sala con Opera 46 (Chromium 59). Por eso se carga en un chunk aparte y solo donde existe BigInt; en esos equipos
// la app arranca igual, sin RUM.
let rum = Promise.resolve(null);

// Solo en producción: las pruebas locales y los deploy previews de Netlify no se mezclan con los datos reales.
const PRODUCTION_HOSTS = ['sorteos.wargos.cloud', 'dreams.sorteos.wargos.cloud', 'sorteos.wgt.pe'];

// Wauth vuelve a /callback con los tokens en el hash (#id_token=…&wsrf=…, wsrf es el refresh token) y RUM guardaba la
// URL completa: en la vista /callback, en el documento que se cargó y como referrer de todos los eventos de la vista
// siguiente. Session Replay ya le quita el hash a las URLs.
const TOKEN_IN_URL = /([#?&](?:id_token|access_token|refresh_token|wsrf)=)[^&#]*/g;

const hideToken = (object, field) => {
  if (typeof object?.[field] === 'string') object[field] = object[field].replace(TOKEN_IN_URL, '$1oculto');
};

export function hideTokens(event) {
  hideToken(event.view, 'url');
  hideToken(event.view, 'referrer');
  hideToken(event.resource, 'url');
  hideToken(event.error?.resource, 'url');
}

// El salaId va en cada evento (@context.salaId, como en fe-runner), para filtrar RUM por sala. SalaSelector lo guarda
// en localStorage y avisa con 'salaChanged', igual que clearSalaSession al borrarlo; 'storage' cubre otras pestañas.
export function trackSala(datadogRum) {
  const update = () => {
    const salaId = localStorage.getItem('salaId');
    if (salaId) datadogRum.setGlobalContextProperty('salaId', salaId);
    else datadogRum.removeGlobalContextProperty('salaId');
  };
  update();
  window.addEventListener('salaChanged', update);
  window.addEventListener('storage', update);
}

export function initDatadog() {
  if (typeof BigInt !== 'function' || !PRODUCTION_HOSTS.includes(window.location.hostname)) return;
  rum = import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      datadogRum.init({
        applicationId: 'b21091bd-2f6e-4e99-9616-9e06407aaa72',
        clientToken: 'pubd35402b2e071a6010ae093e13942b3cc',
        site: 'datadoghq.com',
        service: 'fe-sorteos',
        // El commit del deploy (ver vite.config.js): los equipos que no tocan "Actualizar" siguen con versiones viejas.
        version: __APP_VERSION__,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        // Solo las cabeceras x-datadog-* (como en el SDK v4): el SDK nuevo también manda traceparent, tracestate y baggage,
        // y si el CORS de las APIs no las permite, las llamadas fallan.
        allowedTracingUrls: ["https://sorteos.wgt.pe", "https://api4.wgt.pe", "https://sorteos.wargos.cloud", "https://dreams.sorteos.wargos.cloud", "https://api4.wargos.cloud", "https://api5.wargos.cloud"]
          .map(url => ({ match: url, propagatorTypes: ['datadog'] })),
        propagateTraceBaggage: false,
        beforeSend: hideTokens,
      });
      trackSala(datadogRum);
      return datadogRum;
    })
    .catch(() => null);
}

export function setDatadogUser(user) {
  rum.then((datadogRum) => datadogRum && datadogRum.setUser(user));
}
